import React, { ReactNode, useState } from 'react';
import arrowUp from '@/assets/image/arrow-u.png';
import arrowDown from '@/assets/image/arrow-d.png';
import arrowUpGreen from '@/assets/image/arrow-u-green.png';
import arrowDownGreen from '@/assets/image/arrow-d-green.png';
import { MenuContext } from './context';
import Menu from '.';
import styles from './subMenu.less';

const ITEM_HEIGHT = 76;

const { Consumer, Provider } = MenuContext;

interface ISubMenuContentProps {
  children: ReactNode;
  style?: Object;
  title: ReactNode;
  extend: boolean;
  count: number;
  isNeedHideAll?: boolean;
}

export type SubMenuContentType = React.FC<ISubMenuContentProps>
const SubMenuContent: SubMenuContentType = ({
  title, children, style = {}, extend: defaultExtend, count, isNeedHideAll,
}) => {
  const [extend, setExtend] = useState(defaultExtend);
  const [showAll, setShowAll] = useState(false);

  const getHeight = () => {
    const height = ITEM_HEIGHT * count;
    const bottomHeight = count > 3 ? 30 : 0;
    if (!extend) {
      return 0;
    }
    if (!isNeedHideAll) {
      return height;
    }
    if (!showAll) {
      return Math.min(height, ITEM_HEIGHT * 3) + bottomHeight;
    }
    return height + bottomHeight;
  };

  return (
    <div style={style} className={styles.subMenu}>
      <div className={styles.subMenuTitle} style={style} onClick={() => setExtend(!extend)}>
        <div className={styles.icon}>
          {extend ? <img src={arrowUp} alt="" /> : <img src={arrowDown} alt="" />}
        </div>
        <Menu.Item>{title}</Menu.Item>
      </div>
      <Provider
        value={{
          isSubMenuItem: true,
        }}
      >
        <div
          className={styles.subMenuContent}
          style={{
            height: getHeight() + 'px',
          }}
        >
          {React.Children.map(children, c => c)?.slice(0, isNeedHideAll ? showAll ? count : 3 : count)}
          {count > 3 && isNeedHideAll && (
            <div className={styles.showAll} onClick={() => setShowAll(!showAll)}>
              {showAll ? <img src={arrowUpGreen} alt="" /> : <img src={arrowDownGreen} alt="" />}
            </div>
          )}
        </div>
      </Provider>
    </div>
  );
};

interface ISubMenuProps {
  children: ReactNode;
  style?: Object;
  title: ReactNode;
  keys: string;
}
export type SubMenuType = React.FC<ISubMenuProps>

const SubMenu: SubMenuType = ({
  keys, title, children, style = {},
}) => {
  // 判断子节点是否为 Item
  // ...
  const count = React.Children.count(children);
  return (
    <Consumer>
      {
        (values: any) => {
          const extend = values.defaultOpenKeys.includes(keys);
          return (
            <SubMenuContent
              extend={extend}
              count={count}
              title={title}
              style={style}
              isNeedHideAll={values.isNeedHideAll}
            >
              {children}
            </SubMenuContent>
          );
        }
      }
    </Consumer>
  );
};

export default SubMenu;
